var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"rgqy6KXkN2GDrIkpaqNE4"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { hasConsent, onConsentChange } from "@/utils/cookieConsent"
import * as Sentry from "@sentry/nextjs"

// Session Replay sets the `sentryReplaySession` storage entry, which is a
// "statistics" cookie. Only enable it once the user has consented. Error
// reporting (Sentry core) does not set that entry and keeps running.
// Guarded: a throw here would abort the whole _app chunk and leave the page
// on the SSR loader (happened in prod with Sentry < 7.98, which lacks replayIntegration).
const createReplay = () => {
  try {
    return Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })
  } catch (e) {
    console.error("Sentry Replay unavailable", e)

    return null
  }
}

const replayEnabled = hasConsent("statistics")
const replay = replayEnabled ? createReplay() : null

Sentry.init({
  dsn: process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  enabled: process.env.NEXT_PUBLIC_ENVIRONMENT !== "development",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Replay is added only after "statistics" consent (see below).
  integrations: replay ? [replay] : [],
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === "ui.click" && hint) {
      const { target } = hint.event

      if (target.ariaLabel) {
        breadcrumb.message = target.ariaLabel
      }
    }

    return breadcrumb
  },
})

if (typeof window !== "undefined") {
  let replayAdded = replayEnabled

  onConsentChange(() => {
    if (!replayAdded && hasConsent("statistics")) {
      replayAdded = true
      const lateReplay = createReplay()
      if (lateReplay) Sentry.addIntegration(lateReplay)
    }
  })
}
